import React from 'react';

const CompanyContext = React.createContext({
  company: null,
  setCompany: () => {}
});

export class CompanyProvider extends React.Component {
  constructor(props) {
    super(props);
    const savedCompany = localStorage.getItem('selectedCompany');
    this.state = {
      company: savedCompany || null,
      setCompany: this.setCompany
    };
  }

  setCompany = (company) => {
    localStorage.setItem('selectedCompany', company);
    this.setState({ company });
  };

  render() {
    return (
      <CompanyContext.Provider value={this.state}>
        {this.props.children}
      </CompanyContext.Provider>
    );
  }
}

export const CompanyConsumer = CompanyContext.Consumer;
export default CompanyContext;